<template>
  <Drawer
    width="400"
    :title="`${openedStorageTank ? '编辑' : '新增'}储罐列表`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="储罐名" prop="name">
          <Input
            v-model="formItem.name"
            placeholder="输入储罐名..."
            style="width: 300px"
          />
        </FormItem>
        <FormItem label="储罐容量" prop="capacity">
          <InputNumber
            v-model="formItem.capacity"
            style="width: 300px"
            placeholder="输入储罐容量..."
          />
        </FormItem>
        <FormItem label="储罐价格" prop="cost">
          <InputNumber
            :min="0"
            v-model="formItem.cost"
            placeholder="输入储罐价格..."
          ></InputNumber>
        </FormItem>
        <FormItem label="储罐类型" prop="type">
          <RadioGroup v-model="formItem.type">
            <Radio label="steel">
              <span>不锈钢</span>
            </Radio>
            <Radio label="plastic">
              <span>塑胶桶</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="位置状态" prop="locationStatus">
          <RadioGroup v-model="formItem.locationStatus">
            <Radio label="supplier">
              <span>供应商</span>
            </Radio>
            <Radio label="shippingToCustomer">
              <span>运往客户</span>
            </Radio>
            <Radio label="shippingToFactory">
              <span>运往工厂</span>
            </Radio>
            <Radio label="customer">
              <span>客户</span>
            </Radio>
            <Radio label="factory">
              <span>工厂</span>
            </Radio>
            <Radio label="unknown">
              <span>未知</span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formItem')">保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>


<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "AddStorageTank",
  data() {
    return {
      drawerOpened: false,
      openedStorageTank: null,
      formItem: {
        name: null,
        capacity: null,
        type: null,
        cost: 0,
        locationStatus: null,
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "储罐名为必填",
            trigger: "blur",
          },
        ],
        capacity: [
          {
            required: true,
            type: "number",
            message: "储罐容量为必填项",
            trigger: "blur",
          },
        ],
        type: [
          {
            required: true,
            message: "储罐类型为必选",
            trigger: "submit",
          },
        ],
        locationStatus: [
          {
            required: true,
            message: "位置状态为必选",
            trigger: "submit",
          },
        ],
        cost: [
          {
            required: true,
            type: "number",
            message: "储罐价格为必填项",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    // ...mapState({}),
  },
  methods: {
    ...mapActions({
      createStorageTank: "storageTank/createStorageTankAction",
      // updateTankRental: "storageTank/updateTankRentalAction",
    }),
    async openDrawer(storageTank) {
      this.drawerOpened = true;
      this.openedStorageTank = storageTank;
    },
    handleSubmit(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedStorageTank) {
              // await this.updateTankRental({
              //   id: this.openedTankRental._id,
              //   data: this.formItem,
              // });
            } else {
              await this.createStorageTank(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped></style>